import React from 'react';
import { Box, styled } from '@mui/material';
import { Button } from 'components/Button/Button';

const SubmitButton = styled(Button)(({ theme }) => ({
  borderRadius: theme.spacing(4),
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  alignSelf: 'center',
  paddingLeft: theme.spacing(14),
  paddingRight: theme.spacing(14),
  [theme.breakpoints.down('sm')]: {
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
  },
}));

type AssessmentsQuestionLastQuestionProps = {
  bottomMargin?: number | string;
  card: React.ReactNode;
  showSubmitButton: boolean;
  onSubmit?: () => void;
  isSubmitDisabled?: boolean;
};

export const AssessmentsQuestionLastQuestion = ({
  bottomMargin,
  card,
  showSubmitButton,
  onSubmit,
  isSubmitDisabled,
}: AssessmentsQuestionLastQuestionProps) => (
  <Box style={{ marginBottom: bottomMargin ?? 0 }}>
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {card}
      {showSubmitButton ? (
        <SubmitButton
          id="assessment__mobile-header-submit-button"
          variant="primary"
          size="xlarge"
          onClick={onSubmit}
          disabled={isSubmitDisabled}
          circularProgressProps={{
            size: 24,
          }}
          aria-label="Submit Assessment"
        >
          Submit Assessment
        </SubmitButton>
      ) : null}
    </Box>
  </Box>
);
